import styled from 'styled-components'

const Container = styled.div`
  max-width: ${props => props.theme.containerWidth}px;
  margin: 0 auto;
  padding: 0 10px;
  box-sizing: border-box;
`

export default Container